import { AppState } from '../state/AppState';
import { LayoutType } from '../state/LayoutType';

export function selectLayoutType(state: AppState): LayoutType {
  return state.layoutType;
}
